import { memo, useMemo } from "react";
import { WizardStepContext } from "../Wizard.Parts";
import { Content, Props } from "./WizardStep.Parts";

export const WizardStep = memo(({ isActive, children }: Props) => {
  const stepCtx = useMemo(() => ({ isActive }), [isActive]);

  return (
    <Content $hidden={!isActive}>
      <WizardStepContext.Provider value={stepCtx}>
        {children}
      </WizardStepContext.Provider>
    </Content>
  );
});
